import { Layout, Frame, Button, Page, Toast } from '@shopify/polaris';

import SearchCustomer from './Search.jsx';
import {useState, useEffect, useCallback} from 'react';
import { useHistory } from 'react-router-dom';
import CustomerForm from './Form.jsx';
import Api from '../../helpers/api';

const Customers = () => {

    const history = useHistory();
    const [customer, setCustomer] = useState(null);
    const [billTo, setBillTo] = useState(null);
    const [creating, setCreating] = useState(false);
    const [updating, setUpdating] = useState(false);
    const [loading, setLoading] = useState(false);
    const [user, setUser] = useState({can_manage_on_hold: false, is_admin: false})
    const [toast, setToast] = useState({
        active: false,
        message: ''
    });

    useEffect(() => {
        Api.getMe().then(response => {
            setUser(response.data.user ?? {can_manage_on_hold: false, is_admin: false});
        });
    }, []);

    const toastMarkup = toast.active ? (
        <Toast content={toast.message} duration={3000} onDismiss={() => { setToast({ message: '', active: false }) }} />
    ) : null;


    const assignCustomer = (customer) => {
        history.push(`/customers/${customer.id}`);
        // setCreating(false);
        // setCustomer(customer);
    }

    const pageTitle = () => {
        if (updating) {
            return 'Edit Customer';
        } else if (creating) {
            return 'Create New Customer';
        } else {
            return 'Customers';
        }
    }

    const handleBack = () => {
        if (creating) {
            const confirmationMessage = "You haven't created a new customer - Do you want to exit?";
            if (window.confirm(confirmationMessage)) {
                setCreating(false);
                setUpdating(false);
            }
        } else {
            setCreating(false);
            setUpdating(false);
        }
    }

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const success = urlParams.get('draft_success');

        if ( success ) {
            setToast({ message: 'The draft order was created', active: true })
        }
    }, []);

    const generateOpenCreditReport = useCallback(() => {
        setLoading(true);
        Api
            .generateOpenCreditReport()
            .then(() => {
                setToast({ message: 'You will receive report on your email address.', active: true })
            })
            .catch(() => {
                setToast({ message: 'Server error', active: true })
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    return (
        <Frame>
            <Page
                title={pageTitle()}
                primaryAction={
                    (!creating && !updating) ? <Button  onClick={() => { setCreating(true) }} variant="primary">New Customer</Button>
                        : <Button onClick={() => { handleBack() }}>Go Back</Button>
                }
                secondaryActions={[
                    { content: 'Customers Credit Report', onAction: generateOpenCreditReport, loading: loading },
                    ...(user.is_admin ? [{ content: 'Users Management', onAction: () => history.push('/users') }] : []),
                    { content: 'Users Activity', onAction: () => history.push('/usersActivity') },
                    { content: 'Billing addresses', onAction: () => history.push('/billingAddresses') },
                ]}
            >
                {(creating || updating) ? (
                    <Layout>
                        <Layout.Section>
                            <CustomerForm
                                customer={customer}
                                updating={false}
                                onCustomerCreated={customer => {
                                    assignCustomer(customer);
                                    setToast({ active: true, message: 'Customer Created' });
                                }}
                                creating={creating}
                            />
                        </Layout.Section>
                    </Layout>
                ) : (
                    <Layout>
                        <Layout.Section>
                            {<SearchCustomer onCustomerSelect={(customer) => {
                                assignCustomer(customer);
                            }} />}
                        </Layout.Section>
                    </Layout>
                )}
            </Page>
            {toastMarkup}
        </Frame>
    );
}


export default Customers;
